import React, { useEffect } from 'react';

export default function AnalyticsTracker() {
  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        await fetch(`${BACKEND_URL}/api/analytics/pageview`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page: window.location.pathname,
            user_agent: navigator.userAgent
          }),
        });
      } catch (error) {
        // Silently fail - analytics shouldn't break the site
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, []);

  return null; // This component doesn't render anything
}
